"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryExchangeReverseTokenSimulation = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const queryExchangeReverseTokenSimulation = ({ lcd, contractAddr, amount, pair_contract_address }) => 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(_) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield lcd.wasm.contractQuery(pair_contract_address, {
        reverse_simulation: {
            ask_asset: {
                info: {
                    ANC: {
                        contract_addr: contractAddr,
                    },
                },
                amount: new terra_js_1.Int(new terra_js_1.Dec(amount).mul(1000000)).toString(),
            },
        },
    });
    return response;
});
exports.queryExchangeReverseTokenSimulation = queryExchangeReverseTokenSimulation;
//# sourceMappingURL=reverse-token-simulation.js.map